import { matchRoutes, useLocation } from 'react-router-dom';

import { ClusterSettings, Job } from '@typings';
import { useContextSearchParams } from '@hooks';
import { cn, path } from '@utils';
import { settingsTabs } from '@content';

import { Link } from '@components';

const jobRoute = [{ path: path.job() }];

type Props = {
  jobId: string;
  name?: string;
};

export const JobTabs = ({ jobId, name }: Props) => {
  const { pathname } = useLocation();
  const { contextSearchParams } = useContextSearchParams();

  const routes = matchRoutes(jobRoute, { pathname });

  const isJobRoute = () => {
    const route = path.job();

    if (!routes) {
      return false;
    }

    return routes.some(({ route: { path } }) => path === route);
  };

  const getPath = (tab: Job.Tab | string) => {
    const formattedTab = tab === '/' ? undefined : (tab as Job.Tab);

    return `${path.job(jobId, formattedTab)}?${contextSearchParams}`;
  };

  const makeTab = ({ path, title }: ClusterSettings.Tab) => {
    const tab = path as string;
    const isIndexJobPath = isJobRoute() && path === Job.Tab.Overview;
    const isActive = pathname.includes(`/${tab}`) || isIndexJobPath;
    const isOutputsDisabled = path === Job.Tab.Outputs && !name;

    return (
      <Link
        theme
        key={tab}
        className={cn(
          'block border-b-2 border-transparent pb-4 pt-2 text-h6 capitalize text-neural-04 transition-colors hover:text-rebecca',
          { 'border-primary text-rebecca': isActive },
          { 'pointer-events-none text-neural-02': isOutputsDisabled },
        )}
        to={getPath(tab)}
      >
        {title}
      </Link>
    );
  };

  return (
    <header className="flex gap-10 border-b border-neural-01 px-10 pt-6">
      {settingsTabs.job.map(makeTab)}
    </header>
  );
};
